import { Button } from "@somethings-ui/web";
import { forwardRef } from "react";
import { cn } from "@somethings-ui/core";
import type { ActionSuggestionDescriptor } from "./action-suggestion";

interface ContextSuggestionProps {
  suggestion: ActionSuggestionDescriptor;
  onAccept: () => void;
  onDismiss: () => void;
}

export const ContextSuggestion = forwardRef<
  HTMLElement,
  ContextSuggestionProps
>(function ContextSuggestion({ suggestion, onAccept, onDismiss }, ref) {
  const primary = suggestion.primaryAction;
  const isEmpty = suggestion.kind === "empty";
  const eyebrowLabel =
    suggestion.eyebrow === "how_to_end"
      ? "HOW TO END TODAY"
      : "WHERE I'D START TODAY";

  return (
    <section ref={ref} className="px-4 pt-4">
      <div className="flex flex-col gap-2.5 border-b border-surfaces-divider pb-4">
        <SuggestionEyebrow label={eyebrowLabel} muted={isEmpty} />
        <div className="flex flex-col gap-3">
          <p className="font-body text-body-2 text-text-primary">
            {suggestion.rationale}
          </p>
          {(primary || suggestion.dismissible) && (
            <div className="flex items-center gap-4">
              {primary && (
                <Button
                  variant="primary"
                  size="sm"
                  fullWidth={false}
                  onClick={onAccept}
                >
                  {primary.label}
                </Button>
              )}
              {suggestion.dismissible && (
                <Button
                  variant="quaternary"
                  fullWidth={false}
                  onClick={onDismiss}
                  labelClassName="font-body text-body-3 text-secondary"
                >
                  Not now
                </Button>
              )}
            </div>
          )}
        </div>
      </div>
    </section>
  );
});

function SuggestionEyebrow({
  label,
  muted,
}: {
  label: string;
  muted: boolean;
}) {
  return (
    <div className="flex items-center gap-1.5 font-mono text-xs font-medium tracking-[-0.24px] text-text-tertiary">
      <span
        className={cn(
          "size-1.5 rounded-full",
          muted ? "bg-text-tertiary" : "bg-states-active",
        )}
      />
      <span>{label}</span>
    </div>
  );
}
